/**
 * Instagram Embed Debug Helper
 *
 * 목적: 공식 embed 코드 "생"(blockquote + script)을 그대로 넣었을 때
 * 실제로 렌더가 되는지 환경(CSP/네트워크/차단 등)을 빠르게 확인하는 테스트용.
 *
 * 注意: このモジュールは "escapeしない" で innerHTML を使います。
 * 本番用途では使わない（debug専用）。
 */

import { instagramEmbedForm } from "./instagram-embed-form";

interface InstagramEmbedDebugOptions {
    rootSelector?: string;
}

export class InstagramEmbedDebug {
    private readonly options: Required<InstagramEmbedDebugOptions>;

    /** Initialize debug renderer options. */
    public constructor(options: InstagramEmbedDebugOptions = {}) {
        this.options = {
            rootSelector: options.rootSelector || "[data-instagram-embed-debug]",
        };
    }

    public init(): void {
        this.initInRoot(document);
    }

    /** Initialize debug embeds in the given root. */
    public initInRoot(root: ParentNode): void {
        const nodes = instagramEmbedForm.getDebugRoots(root, this.options.rootSelector);

        nodes.forEach((element) => {
            if (element.dataset.instagramEmbedDebugInit === "1") {
                return;
            }
            element.dataset.instagramEmbedDebugInit = "1";

            const html = (element.getAttribute("data-embed-html") || "").trim();
            if (!html) {
                return;
            }

            element.innerHTML = html;
            InstagramEmbedDebug.tryProcess();
        });
    }

    public static tryProcess(): void {
        try {
            const instgrm = Reflect.get(globalThis, "instgrm");
            const embeds = instgrm && typeof instgrm === "object" ? Reflect.get(instgrm, "Embeds") : null;
            const process = embeds && typeof embeds === "object" ? Reflect.get(embeds, "process") : null;

            if (typeof process === "function") {
                process.call(embeds);
            }
        } catch {
            // ignore
        }
    }
}
